import { render, staticRenderFns } from "./EditorButton.vue?vue&type=template&id=d5e65a42&scoped=true&"
import script from "./EditorButton.vue?vue&type=script&lang=js&"
export * from "./EditorButton.vue?vue&type=script&lang=js&"
import style0 from "./EditorButton.vue?vue&type=style&index=0&id=d5e65a42&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e65a42",
  null
  
)

export default component.exports